/*
 * Состояния сетки: загрузка, пустота, выходной, устаревшие данные.
 *
 * Это не «экраны вместо журнала». Каркас загрузки повторяет форму сетки, а не заменяет её
 * спиннером: администратор по расположению колонок уже начинает ориентироваться (ТЗ §2.11.1).
 */

/* ─────────── каркас загрузки ─────────── */

.skeleton {
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  background: var(--bg-workspace);
}

.skeletonScale {
  flex: none;
  width: var(--grid-time-column);
  border-right: 1px solid var(--border);
}

.skeletonRow {
  height: 52px;
  padding: 2px var(--space-2) 0 0;
  font-size: var(--font-size-sm);
  font-variant-numeric: tabular-nums;
  color: var(--text-faint);
  text-align: right;
}

.skeletonColumns {
  display: flex;
  flex: 1;
  min-width: 0;
}

.skeletonColumn {
  position: relative;
  flex: 1;
  min-width: 0;
  border-right: 1px solid var(--border);
}

.skeletonHeader {
  display: flex;
  gap: 7px;
  align-items: center;
  height: var(--grid-master-header);
  padding: 0 var(--space-2);
  background: var(--bg-card);
  border-bottom: 1px solid var(--border-strong);
}

.skeletonAvatar {
  flex: none;
  width: 26px;
  height: 26px;
  border-radius: 50%;
}

.skeletonHeaderText {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.skeletonBlock {
  position: absolute;
  right: 3px;
  left: 5px;
  background: var(--bg-sunken);
  border-radius: var(--radius-sm);
}

/* ─────────── пустота и выходной ─────────── */

.centered {
  display: flex;
  flex: 1;
  align-items: flex-start;
  justify-content: center;
  min-height: 0;
  padding: var(--space-6) var(--space-4);
  overflow: auto;
}

.empty {
  max-width: 520px;
  padding: 22px 18px;
  background: var(--bg-workspace);
  border: 1px dashed var(--border-strong);
  border-radius: var(--radius-lg);
}

/* Без прав действия нет — и кнопки тоже нет: она бы только раздражала (§6 макета). */
.emptyQuiet {
  padding: var(--space-4) 18px;
}

.emptyTitle {
  margin: 0 0 6px;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
}

.emptyText {
  margin: 0;
  font-size: var(--font-size-md);
  line-height: 1.5;
  color: var(--text-secondary);
  text-wrap: pretty;
}

.emptyActions {
  display: flex;
  gap: var(--space-2);
  margin-top: var(--space-3);
}

.primary {
  padding: 6px 13px;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-on-nav-active);
  cursor: pointer;
  background: var(--accent);
  border: 1px solid var(--accent);
  border-radius: 7px;
}

.primary:hover {
  background: var(--accent-hover);
  border-color: var(--accent-hover);
}

/* ─────────── данные устарели ─────────── */

/*
 * Возраст данных показывается всегда, а не только когда он велик (ТЗ §2.11.4). Это НЕ
 * всплывающее сообщение: пока связи нет, это состояние экрана, и оно остаётся на месте.
 */
.stale {
  display: flex;
  flex: none;
  gap: var(--space-3);
  align-items: center;
  padding: 7px var(--space-4);
  font-size: var(--font-size-sm);
  color: var(--stripe-offline-fg);
  background: var(--stripe-offline-bg);
}

.staleTitle {
  flex: none;
  font-weight: var(--font-weight-semibold);
}

.staleText {
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  opacity: 0.9;
}

.staleAction {
  margin-left: auto;
  padding: 0;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
  background: none;
  border: 0;
}
